import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { ADMIN_TIME_OFF } from '@ApplicationWide/permissions/constants';
import React from 'react';

const AdminCreatePolicyPage = React.lazy(() => import('../../../pages/Admin/TimeOff/PolicyPage/AdminCreatePolicyPage'));
const AdminEditPolicyPage = React.lazy(() => import('../../../pages/Admin/TimeOff/PolicyPage/AdminEditPolicyPage'));

export default [
  {
    group: ADMIN,
    to: '/administration/time-off/new-policy',
    route: '/administration/time-off/new-policy',
    component: AdminCreatePolicyPage,
    requiredRoles: ['admin', 'super_admin'],
    adminVisibilityPermission: ADMIN_TIME_OFF,
    hasNavBar: true,
  },
  {
    group: ADMIN,
    to: '/administration/time-off/edit-policy/:policyId',
    route: '/administration/time-off/edit-policy/:policyId',
    component: AdminEditPolicyPage,
    requiredRoles: ['admin', 'super_admin'],
    adminVisibilityPermission: ADMIN_TIME_OFF,
    hasNavBar: true,
  },
];
